// removed by extract-text-webpack-plugin
module.exports = {"root":"_154Xx8I","root_isButton":"_1s7t8Ai","root_isLink":"_3r22lb7","icon":"_2LFlynZ","iconSvg":"Iexr8ns","buttonRoot":"_1he74Cw","iconSvg_isSaved":"_1OVQicD","iconSvg_isApplied":"TPvTZwp"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/SearchResultList/components/JobItem/components/SaveJob/SaveJob.less
 ** module id = 813
 ** module chunks = 0
 **/